import { GenericMoleculeOverviewRowPanelDashboardComponent } from '../abstract';

// tslint:disable-next-line:max-line-length
export class MoleculeOverviewRowPanelDashboardVhostsComponent extends GenericMoleculeOverviewRowPanelDashboardComponent {
    public template = require('./dashboard-vhosts.html');
    protected type = 'vhosts';
}
